import { useState } from "react";
import { toast } from "sonner";
import { BadgeCheck } from "lucide-react";
import { useApp, formatMoney, useCanEdit } from "@/lib/app-context";
import { monthLabel } from "@/lib/sheet-utils";
import { Button } from "@/components/ui/button";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export function SettleButton({ staffId, name, balance, month, currency, onDone }) {
  const { api } = useApp();
  const canEdit = useCanEdit();
  const [open, setOpen] = useState(false);
  const amount = formatMoney(Math.abs(balance), currency);
  const settle = async () => {
    try {
      await api("post", `/staff/${staffId}/settle`);
      toast.success(`Balance settled for ${name}`);
      onDone();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not settle");
    }
  };
  if (!balance || !canEdit) return null;
  return (
    <>
      <Button onClick={() => setOpen(true)} className="bg-teal-600 hover:bg-teal-700" data-testid="settle-balance-button">
        <BadgeCheck size={16} />Settle balance
      </Button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent data-testid="settle-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle className="font-heading">Settle {name}'s balance?</AlertDialogTitle>
            <AlertDialogDescription>
              {balance > 0 ? `This records ${amount} paid to ${name}` : `This records ${amount} received from ${name}`} as the final payment in {monthLabel(month)}. The balance becomes zero and nothing carries forward.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="settle-cancel-button">Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={settle} className="bg-teal-600 hover:bg-teal-700" data-testid="settle-confirm-button">Settle {amount}</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
